import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import './index.css'
import Root from './Root.jsx'

const isDemoMode = window.location.pathname.startsWith('/demo') || import.meta.env.VITE_DEMO_MODE === 'mock';
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

console.log('Sentry Check:', { hasDsn: !!sentryDsn, isDemoMode });

if (sentryDsn && !isDemoMode) {
  console.log('Initializing Sentry...');
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    // ... rest unchanged
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, 
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/sink\.mqgauss\.com/, /^https:\/\/second-brain-2d68a\.web\.app/, /^https:\/\/second-brain\.mq-gauss\.workers\.dev/, /^https:\/\/second-brain-6p5\.pages\.dev/],
    // Session Replay
    replaysSessionSampleRate: 0.1, 
    replaysOnErrorSampleRate: 1.0,
    // Enable logs to be sent to Sentry
    enableLogs: true
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Root />
  </StrictMode>,
)
